import { configureStore, Action } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';
import rootReducer from './rootReducer';

export const getCommonStore = ({ isProd }: { isProd?: boolean }) => {
  return configureStore({
    reducer: rootReducer,
    devTools: !isProd,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = ReturnType<typeof getCommonStore>['dispatch'];
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export * from './activity';
export * from './card';
export * from './page';
export * from './user';
